




































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";

import { Dialog, Popup } from "vant";
import axios from "axios";
import { Notify } from "vant";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {},
})
export default class NewCategory extends Vue {
  @Prop() show!: any;

  @Prop() CategoryId!: any;
  @Prop() episodes!: any;
  @Prop() Categories!: any;
  @Prop() CategoryName!: any;
  categoriesLength: number = 0;
  errors: any = [];
  episodeItems = ["AUDIO", "VIDEO"];
  apiForNewCategory = "";
  new_episdoe: any = {
    id: null,
    title: null,
    subTitle: null,
    artist: null,
    contributorName: null,
    description: null,
    duration: null,
    episodeType: "AUDIO",
    episodeUrl: null,
    imageUrl: null,
    offlineImageUrl: null,
  };

  new_category: any = {
    id: null,
    name: null,
    nameBn: null,
    iconUrl: null,
    offlineIconUrl: null,
  };

  checkRequired() {
    return true;
    // if (this.new_episdoe.episodeUrl && this.new_episdoe.title) {
    //   return true;
    // }
    // this.errors = [];
    // if (!this.new_episdoe.episodeUrl) {
    //   this.errors.push("name required.");
    // }
    // if (!this.new_episdoe.title) {
    //   this.errors.push("title required.");
    // }
  }
  AddNewCategory() {
    if (this.checkRequired()) {
      this.Categories.push({
        id: "category" + (this.Categories.length + 2),
        name: this.new_category.name,
        nameBn: this.new_category.nameBn,
        iconUrl: this.new_category.iconUrl,
        offlineIconUrl: this.new_category.offlineIconUrl,
      });
      this.categoriesLength = Number(this.Categories.length);

      const RequestedData = {
        category: {
          id: "category" + this.categoriesLength,
          name: this.new_category.name,
          nameBn: this.new_category.nameBn,
          iconUrl: this.new_category.iconUrl,
          offlineIconUrl: this.new_category.offlineIconUrl,
        },
      };
      if (this.CategoryName == "conversation") {
        this.apiForNewCategory =
          "https://api.englishjanala.com:8443/v1/englishjanala/conversation/ConversationService/AddConversationCategory";
      } else if (this.CategoryName == "grammar") {
        this.apiForNewCategory =
          "https://api.englishjanala.com:8443/v1/englishjanala/grammar/GrammarService/AddGrammarCategory";
      } else if (this.CategoryName == "words") {
        this.apiForNewCategory =
          "https://api.englishjanala.com:8443/v1/englishjanala/word/WordService/AddWordCategory";
      }
      const response = axios
        .post(this.apiForNewCategory, RequestedData)
        .then()
        .catch((error) => {
          Notify({ type: "danger", message: "Category is not added" });
        });
      Notify({ type: "success", message: "Category added" });
    }
  }

  showPopup() {
    this.show = true;
  }
}
